/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: ncxDEJ0p8q40
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicFormElement.module.css"; // plasmic-import: ncxDEJ0p8q40/css

createPlasmicElementProxy;

export const PlasmicFormElement__VariantProps = new Array("status");

export const PlasmicFormElement__ArgProps = new Array(
  "formInputComponent",
  "name",
  "showRequired",
  "required",
  "label",
  "showHelperText",
  "helperText",
  "showFormElement"
);

const $$ = {};

function PlasmicFormElement__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showRequired: false,
          required: false,
          label: "label",
          showHelperText: true,
          showFormElement: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"formElement"}
      data-plasmic-override={overrides.formElement}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.formElement,
        {
          [sty.formElementstatus_normal]: hasVariant($state, "status", "normal")
        }
      )}
      id={"Id"}
    >
      <div
        data-plasmic-name={"labelWrapper"}
        data-plasmic-override={overrides.labelWrapper}
        className={classNames(projectcss.all, sty.labelWrapper, {
          [sty.labelWrapperstatus_normal]: hasVariant(
            $state,
            "status",
            "normal"
          )
        })}
      >
        {(() => {
          try {
            return $props.showRequired;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <label
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.label__jDQn4,
              {
                [sty.labelstatus_disabled__jDQn4H3H8]: hasVariant(
                  $state,
                  "status",
                  "disabled"
                ),
                [sty.labelstatus_error__jDQn4OzHue]: hasVariant(
                  $state,
                  "status",
                  "error"
                ),
                [sty.labelstatus_normal__jDQn4Hh7QZ]: hasVariant(
                  $state,
                  "status",
                  "normal"
                )
              }
            )}
          >
            {"*"}
          </label>
        ) : null}
        <label
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.label__qt2X,
            {
              [sty.labelstatus_disabled__qt2XH3H8]: hasVariant(
                $state,
                "status",
                "disabled"
              ),
              [sty.labelstatus_error__qt2XozHue]: hasVariant(
                $state,
                "status",
                "error"
              ),
              [sty.labelstatus_normal__qt2Xhh7QZ]: hasVariant(
                $state,
                "status",
                "normal"
              )
            }
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.label;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "label";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </label>
      </div>
      <div
        data-plasmic-name={"slotWrapper"}
        data-plasmic-override={overrides.slotWrapper}
        className={classNames(projectcss.all, sty.slotWrapper)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.formInputComponent
        })}
      </div>
      {(() => {
        try {
          return $props.showHelperText;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"helperTextWrapper"}
          data-plasmic-override={overrides.helperTextWrapper}
          className={classNames(projectcss.all, sty.helperTextWrapper, {
            [sty.helperTextWrapperstatus_normal]: hasVariant(
              $state,
              "status",
              "normal"
            )
          })}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text,
              {
                [sty.textstatus_disabled]: hasVariant(
                  $state,
                  "status",
                  "disabled"
                ),
                [sty.textstatus_error]: hasVariant($state, "status", "error"),
                [sty.textstatus_normal]: hasVariant($state, "status", "normal")
              }
            )}
          >
            <React.Fragment>
              {(() => {
                try {
                  return $props.helperText;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "Helper text.";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
        </div>
      ) : null}
    </div>
  );
}

const PlasmicDescendants = {
  formElement: [
    "formElement",
    "labelWrapper",
    "slotWrapper",
    "helperTextWrapper",
    "text"
  ],

  labelWrapper: ["labelWrapper"],
  slotWrapper: ["slotWrapper"],
  helperTextWrapper: ["helperTextWrapper", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFormElement__ArgProps,
          internalVariantPropNames: PlasmicFormElement__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFormElement__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "formElement") {
    func.displayName = "PlasmicFormElement";
  } else {
    func.displayName = `PlasmicFormElement.${nodeName}`;
  }
  return func;
}

export const PlasmicFormElement = Object.assign(
  // Top-level PlasmicFormElement renders the root element
  makeNodeComponent("formElement"),
  {
    // Helper components rendering sub-elements
    labelWrapper: makeNodeComponent("labelWrapper"),
    slotWrapper: makeNodeComponent("slotWrapper"),
    helperTextWrapper: makeNodeComponent("helperTextWrapper"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicFormElement
    internalVariantProps: PlasmicFormElement__VariantProps,
    internalArgProps: PlasmicFormElement__ArgProps
  }
);

export default PlasmicFormElement;
/* prettier-ignore-end */
